export default __webpack_public_path__ + "static/media/submenu-robot-R2.49877589.png";